import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskFiles.components.BulkDeliverFilesModal.title',
    defaultMessage: 'Deliver selected files as ZIP archive',
  },
  customerMessageLabel: {
    id: 'containers.OrderPage.components.TaskFiles.components.BulkDeliverFilesModal.customerMessageLabel',
    defaultMessage: 'Additional message to customer',
  },
  customerMessagePlaceholder: {
    id: 'containers.OrderPage.components.TaskFiles.components.BulkDeliverFilesModal.customerMessagePlaceholder',
    defaultMessage: 'Message to customer contacts',
  },
  sideEffects: {
    id: 'containers.OrderPage.components.TaskFiles.components.BulkDeliverFilesModal.sideEffects',
    defaultMessage: `
      <li>All selected files will be delivered</li>
      <li>It will possible trigger an e-mail to:Contact, CC Contact, Coordinator and CC Coordinator</li>
    `
  },
  loading: {
    id: 'containers.OrderPage.components.TaskFiles.components.BulkDeliverFilesModal.loading',
    defaultMessage: 'Delivering...',
  },
  submit: {
    id: 'containers.OrderPage.components.TaskFiles.components.BulkDeliverFilesModal.submit',
    defaultMessage: 'Deliver as ZIP',
  },
  success: {
    id: 'containers.OrderPage.components.TaskFiles.components.BulkDeliverFilesModal.success',
    defaultMessage: 'The selected files will be delivered to the customer',
  },
  error: {
    id: 'containers.OrderPage.components.TaskFiles.components.BulkDeliverFilesModal.error',
    defaultMessage: 'Something went wrong, trying to deliver the selected files. Try again later.',
  },
})
